module.exports = __webpack_public_path__ + "static/media/DSC00219.02e0d3d7.jpg";